import React from 'react';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

const mutation = gql`
  mutation jobSignOffDecline($cloudId: String!, $note: String!) {
    jobSignOffDecline(input: { cloudId: $cloudId, note: $note }) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/jobSignOffDecline').type;

export type JobSignOffDeclineVariables = OperationVariables<typeof mutation>;
export type JobSignOffDeclineResult = OperationData<typeof mutation>;

export const useJobSignOffDecline = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        refetchQueries: [
          'GetJob',
          'GetJobComments',
          'GetNotificationCountForUser',
        ],
        awaitRefetchQueries: true,
        update(cache) {
          cache.evict({ fieldName: 'getJobSignOffs' });
        },
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
